module.exports = "/assets/2729cd9d1ebcb1231a6c838a956560fa.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos-small/CM.png
// module id = 2398
// module chunks = 0